const base64UrlToArrayBuffer = (value = "") => {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = `${base64}${"=".repeat((4 - (base64.length % 4)) % 4)}`;
  const binary = window.atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes.buffer;
};

const arrayBufferToBase64Url = (buffer) => {
  if (!buffer) return null;
  const bytes = new Uint8Array(buffer);
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return window.btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
};

export const isWebAuthnSupported = () =>
  typeof window !== "undefined" &&
  Boolean(window.PublicKeyCredential) &&
  Boolean(window.navigator?.credentials);

export const decodeCreationOptions = (options = {}) => ({
  ...options,
  challenge: base64UrlToArrayBuffer(options.challenge),
  user: {
    ...(options.user || {}),
    id: base64UrlToArrayBuffer(options.user?.id),
  },
  excludeCredentials: (options.excludeCredentials || []).map((credential) => ({
    ...credential,
    id: base64UrlToArrayBuffer(credential.id),
  })),
});

export const decodeRequestOptions = (options = {}) => ({
  ...options,
  challenge: base64UrlToArrayBuffer(options.challenge),
  allowCredentials: (options.allowCredentials || []).map((credential) => ({
    ...credential,
    id: base64UrlToArrayBuffer(credential.id),
  })),
});

export const serializeCredential = (credential) => {
  const response = credential.response || {};
  const serializedResponse = {
    clientDataJSON: arrayBufferToBase64Url(response.clientDataJSON),
  };

  if (response.attestationObject) {
    serializedResponse.attestationObject = arrayBufferToBase64Url(response.attestationObject);
    if (typeof response.getTransports === "function") {
      serializedResponse.transports = response.getTransports();
    }
  }

  if (response.authenticatorData) {
    serializedResponse.authenticatorData = arrayBufferToBase64Url(response.authenticatorData);
  }

  if (response.signature) {
    serializedResponse.signature = arrayBufferToBase64Url(response.signature);
  }

  if (response.userHandle) {
    serializedResponse.userHandle = arrayBufferToBase64Url(response.userHandle);
  }

  return {
    id: credential.id,
    rawId: arrayBufferToBase64Url(credential.rawId),
    type: credential.type,
    authenticatorAttachment: credential.authenticatorAttachment || null,
    response: serializedResponse,
    clientExtensionResults:
      typeof credential.getClientExtensionResults === "function"
        ? credential.getClientExtensionResults()
        : {},
  };
};
